import { UserLoggedInNavigatorParamList } from "./UserLoggedInNavigatorParamList";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

export const UserLoggedInNavigator =
  createNativeStackNavigator<UserLoggedInNavigatorParamList>();
